import React, {Fragment, PureComponent} from "react";
import {Link} from "react-router-dom";
import {toastr} from "react-redux-toastr";
import {connect} from "react-redux";
import api from "../../../api.js";
import Date from "../Moment/Date.jsx";
import {isArray} from "validate.js";
import {AlertCircle} from "react-feather";

import connectModal from "../Modals/connect.js";
import ConfirmModal from "../Modals/ConfirmModal/ConfirmModal.jsx";
import SimpleModal from "../Modals/SimpleModal/SimpleModal.jsx";

import FreelanceDashboardAvailabilityForm
  from "../Forms/FreelanceDashboardAvailabilityForm/FreelanceDashboardAvailabilityForm.jsx";
import FreelanceDashboardHiddenForm
  from "../Forms/FreelanceDashboardHiddenForm/FreelanceDashboardHiddenForm.jsx";

import Card from "../Styled/Dasboard/Card.jsx";
import CardCol from "../Styled/Dasboard/CardCol.jsx";
import CardRow from "../Styled/Dasboard/CardRow.jsx";

import './FreelanceAvailability.scss'

export const name = 'FreelanceAvailabilityForm';

const IN_PROGRESSI_PROCESS = 'wei_in_process'
class FreelanceAvailability extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user,
      freelance: this.props.freelance,
      userId: this.props.user && this.props.user.id ? this.props.user.id: undefined,
      missionName: undefined,
      loading: false,
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (prevState.userId !== this.state.userId) {
      await this.loadData();
    }
  };

  loadData = async () => {
    if(!this.state.userId || !this.state.user || !this.state.user.isProgessiActive) {
      this.setState({missionName: undefined})
      return
    }

    this.setState({loading: true});

    api.progessi.getWorkEffortItemsForMe()
      .then((response) => {
        const missions = response.data

        let currentMission = undefined
        if(isArray(missions) && missions.length > 0) {
          currentMission = missions.find((mission) => {
            return mission.availability_status_id === IN_PROGRESSI_PROCESS
          })
          if(currentMission && currentMission.work_effort_name) {
            this.setState({missionName: currentMission.work_effort_name})
          }
        }
      }).catch((error) => {
        console.error({error})
      }).finally(() => {
        this.setState({loading: false})
      })
  }

  submitFreelanceData = async (data) => {
    const {freelance} = this.props
    const agentId = freelance?.agent.id ?? undefined

    const freelanceData = {
      ...data,
      ...((agentId)? {agent: agentId}: {}),
      freelance: this.props.freelance.id,
    }

    return await api.freelances.edit(freelanceData)
      .then((response) => {
        this.setState({freelance: response.data})
        toastr.success('La disponibilité a été modifiée avec succès')
        return true
      })
      .catch((error) => {
        console.error({error})

        if(error && error.data && error.data.errors ) {
          const msg = error.data.errors
            .map((err) => {
              if (err.message) {
                return err.message
              }
              return undefined
            })
            .filter((errMsg) => {return !!errMsg})
            .join('\n')

          toastr.error(`${msg}`)
          return false
        }

        toastr.error('Une erreur est survenue à la modification de la disponibilité')
        return false
      })
  }
  handleDateChange = (isoStrDate) => {
    this.submitFreelanceData({date_available: isoStrDate,})
  }

  handlePublicVisibilityChange = async (event, value) => {
    return await this.submitFreelanceData({public: value,})
  }

  openSimpleModal = () => {
    this.props.openSimpleModal({
      header: 'À la recherche de missions ?',
      body: <CardRow direction="column">
        <CardCol p="0 25px" gap="0" >
          <p className="dashboard-card-col-txt">Vous êtes désormais considéré comme consultant ouvert à des missions.</p>
          <p className="dashboard-card-col-txt">À très vite pour de nouvelles opportunités !</p>
        </CardCol></CardRow>,
    });
  }

  setFreelanceFree = () => {
    const confirmAction = () => { return this.submitFreelanceData({cdi: false,})
      .then((response) => {
        if(response) {
          this.openSimpleModal()
        }
      })}
    
    this.props.openConfirmModal({
      header: 'À la recherche de missions ?',
      body: <CardRow direction="column">
        <CardCol p="0 25px" gap="0" >
          <p className="dashboard-card-col-txt">Vous vous apprêtez à qualifier votre profil en tant que consultant et non plus en CDI. Cela signifie que nous pourrons vous contacter pour nos missions.</p>
          <p className="dashboard-card-col-txt">Êtes vous sûr(e) de vouloir continuer ?</p>
        </CardCol></CardRow>,
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
      confirmAction: confirmAction,
    });
  }

  render() {
    const { link, generate} = this.props
    const {user, freelance} = this.state

    if(user && user.isProgessiActive){
      return (<Card
        className="dashboard-card-disabled dashboard-card-availability"
        title={'Je suis en mission avec Twineeds'}>
        <Fragment>
          <CardRow gap="15px" direction="column" wrap="nowrap">
            <CardCol className="dashboard-card-col-secondary">Informations de la mission</CardCol>
            <CardCol className="dashboard-card-col-txt">Nom de la mission : {this.state.missionName}</CardCol>

            <CardCol>
              <a
                className="btn btn-primary"
                href="https://twineeds.progessi.com/"
                target="_blank"
                rel="noopener noreferrer">
                Valider mon CRA et déposer ma facture
              </a>
            </CardCol>

            <CardCol className="dashboard-card-col-secondary">Informations de votre profil sur la plateforme</CardCol>
            <CardCol>
              <Link
                className="btn btn-primary"
                to={generate({
                  name: 'edit-freelance.my-search',
                })}>
                Modifier ma disponibilité et visibilité
              </Link>
            </CardCol>
          </CardRow>
        </Fragment>
      </Card>)
    }

    if(freelance.cdi) {
      return(<Card
        className="dashboard-card-disabled dashboard-card-availability"
        title={'Je suis actuellement en CDI'}>

        <CardRow direction="column">
          <CardCol p="0 25px" gap="0" >
            <p className="dashboard-card-col-txt">
              Vous êtes considéré(e) comme indisponible pour des missions car actuellement en CDI.{' '}
              Votre profil sur la plateforme est donc masqué.{' '}
              Vous pouvez à tout moment changer votre statut et vous rendre disponible en cliquant sur le bouton ci-dessous.
            </p>
          </CardCol>
          <CardCol align={'center'}>
            <button
              className="btn btn-primary"
              onClick={this.setFreelanceFree} >
              Je suis de nouveau à la recherche de mission
            </button>
          </CardCol>
          <CardCol p="0 25px" gap="0" >
            <p className="dashboard-card-col-txt" >
              <AlertCircle fill="red" color="white" style={{transform: 'translate(0, 6px)'}}/>
              <span >Vous ne recevez plus d'alertes pour les missions</span>
            </p>
          </CardCol>
        </CardRow>
      </Card>)
    }

    if(!freelance.public) {
      return (
        <Card
          className="dashboard-card-disabled dashboard-card-availability"
          title={'Profil masqué'}>
          <CardRow direction="column" className="hidden-txt">
            <CardCol p="0 25px" gap="0" >
              <p className="dashboard-card-col-txt">
                Votre profil est actuellement masqué sur notre plateforme. Cela signifie qu'il n'est pas visible pour les clients inscrits.
              </p>
            </CardCol>
            <CardCol align="center" >
              <CardRow justify="center" p={0}>
                <CardCol align="center">
                  <Link
                    to={generate({name: 'offers'})}
                    className="btn btn-primary">Voir les missions</Link>
                </CardCol>
              </CardRow>
            </CardCol>
          </CardRow>

          <FreelanceDashboardHiddenForm
            handlePublicVisibilityChange={this.handlePublicVisibilityChange}
            enableReinitialize={true}
            initialValues={{freelance}}/>

          <CardRow p="0px 25px 25px 25px" align="center" justify="flex-start">
            <CardCol flex="1">
              <label htmlFor="">Date de disponibilité :</label>
            </CardCol>
            <CardCol flex="1">
              <Date date={freelance.date_available} />
            </CardCol>
          </CardRow>
        </Card>
      )
    }

    const missions = freelance?.experiences?.length ? freelance.experiences : []
    const mission = (missions.length > 0 )? missions[0]: {}
    return (
      <Card className="dashboard-card-primary dashboard-card-availability" title={'Je suis disponible'}>
        <FreelanceDashboardAvailabilityForm
          handleDateChange={this.handleDateChange}
          handlePublicVisibilityChange={this.handlePublicVisibilityChange}
          enableReinitialize={true}
          initialValues={{freelance}}/>

        <CardRow p="0 25px" gap="0" className='mission'>
          <CardCol>
            <CardRow p="10px 0" gap="0"justify={'center'}>
              <CardCol flex="unset" p="0">
                Dernière mission renseignée sur mon profil
              </CardCol>
            </CardRow>
            <CardRow p="10px 0" align="center">
              <CardCol flex={1} >
                <CardRow direction="column" gap="0" p="0">
                  <CardCol txt={mission?.title ?? ''}/>
                  <CardCol txt={mission?.company ?? ''}/>
                  <CardCol>
                    <Fragment>
                      {(mission.start) && <Date format={'MM/yyyy'} date={mission.start}/>}
                      - {' '}
                      {(mission.end) && <Date format={'MM/yyyy'} date={mission.end}/>}
                    </Fragment>
                  </CardCol>
                </CardRow>
              </CardCol>
              <CardCol flex={'unset'}>
                <Link
                  className="btn btn-primary"
                  to={generate({name: `${link.menu}.mission`, parameters: link.parameters, search: link.search})}
                >
                  Mettre à jour
                </Link>
              </CardCol>
            </CardRow>
          </CardCol>
        </CardRow>
        <CardRow justify={'center'} align={'center'}>
          <CardCol flex="unset">
            <Link
              className="btn btn-default"
              to={generate({
                name: 'edit-freelance.my-search',
              })}>
              Je ne suis plus disponible
            </Link>
          </CardCol>
        </CardRow>
      </Card>
    )
  }
}

export default connect(
  (state) => ({})
)(connectModal({ConfirmModal, SimpleModal}, FreelanceAvailability));
